"use client";

import { c as _c } from "react/compiler-runtime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useCallback } from "react";
import WaveDropTime from "./time/WaveDropTime";
interface DropMinimalIdentityRowProps {
  readonly drop: ApiDrop;
}
export default function DropMinimalIdentityRow(t0) {
  const $ = _c(19);
  const {
    drop
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router) {
    t1 = (event, path) => {
      event.preventDefault();
      event.stopPropagation();
      router.push(path);
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleNavigation = t1;
  const t2 = drop.author.handle ?? drop.author.id;
  const t3 = `/${drop.author.handle ?? drop.author.primary_address}`;
  let t4;
  if ($[2] !== drop.author.handle || $[3] !== drop.author.primary_address || $[4] !== handleNavigation) {
    t4 = event_0 => handleNavigation(event_0, `/${drop.author.handle ?? drop.author.primary_address}`);
    $[2] = drop.author.handle;
    $[3] = drop.author.primary_address;
    $[4] = handleNavigation;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = drop.author.handle ?? drop.author.primary_address;
  let t6;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = <Link href={t3} onClick={t4} className="tw-text-iron-200 tw-no-underline tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-opacity-80 desktop-hover:hover:tw-underline">{t5}</Link>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t6) {
    t7 = <p className="tw-mb-0 tw-text-sm tw-font-semibold tw-leading-none"><UserProfileTooltipWrapper user={t2}>{t6}</UserProfileTooltipWrapper></p>;
    $[10] = t2;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="tw-size-[3px] tw-flex-shrink-0 tw-rounded-full tw-bg-iron-600" />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== drop.created_at) {
    t9 = <WaveDropTime timestamp={drop.created_at} />;
    $[14] = drop.created_at;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7 || $[17] !== t9) {
    t10 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-1.5 tw-gap-y-1">{t7}{t8}{t9}</div>;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}